import { loading } from '@/common/loading'
import { getAlreadySendInfo, getUserInfoAjax2, preDownloadPdfFile, getSendUserList, pushReport} from '@/api/baseMsg'
import { Toast } from "vant";
import previewPDF from "@/components/previewPDF/index";
import config from '@/config/index'
import axios from "axios";
export default {
  name: "examine",
  components:{
    previewPDF
  },
  data() {
    return {
      option: [],
      List: [],
      searchName: '',
      orgId: '',
      areaName: '',
      pdfParams:{
        showPdf: false,
        data: ''
      },
      date: {
        startDate: '',
        endDate: '',
        type: '',
        visible: false,
        currentDate: new Date()
      },
      share: {
        visible: false,
        searchName: '',
        list: [],
        row: {},
      }
    }
  },
  created() {
    this.init();
  },
  mounted() {
    window.addEventListener('scroll', this.scrollToTop);
  },
  destroyed() {
    window.removeEventListener('scroll', this.scrollToTop)
  },
  methods: {
    init() {
      loading(true);
      this.getUserInfoAjax();
    },
    handShare(row) {
      this.share.visible = true
      this.share.list = []
      this.share.searchName = ''
      this.share.row = row
      this.onSearch()
    },
    onSearch() {
      getSendUserList({searchName: this.share.searchName}).then(res=> {
        if(res.code == 200) {
          this.share.list = res.data
        }
      })
    },
    handTs() {
      let arr = []
      this.share.list.forEach(i=> {
        if(i.checked) {
          arr.push(i.id)
        }
      })
      if(arr.length == 0 ) {
        return Toast.fail("请至少选择一条数据!")
      }
      loading(true)
      const params = {
        userIds: arr.join(),
        ids: this.share.row.id,
        checkMethod: [0, 1].join()
      }
      pushReport(params).then(res=> {
        if(res.code == 200 ) {
          Toast.success("发送成功!")
      this.share.visible = false
        }
        loading(false)
      })

    },
    getUserInfoAjax() {
      getUserInfoAjax2().then(res=> {
        if(res.code == 200) {
          this.orgId = res.data.orgId
          this.handQuery()
        }
      })
    },
    handQuery() {
      loading(true);
      const params = {
        currentPage: 1,
        pageSize: 99999,
        searchName: this.searchName ? this.searchName : '',
        checkLower: true,
        reportArea: this.orgId,
        dateFrom: this.date.startDate,
        dateTo: this.date.endDate,
        areaName: this.areaName
      }
      getAlreadySendInfo(params).then(res=> {
        this.List = res.data.list
        loading(false);
      })
      
    },
    handFill(item) {
      loading(true)
      preDownloadPdfFile({reportId: item.id}).then(res=> {
        if(res.code == 200) {
          axios({
              url: config.devProxy +
              `/ythyw/monitorReportUrls/downloadPdfFile?reportId=${item.id}`, //接口地址
              method: "post",
              responseType: "blob",
            }).then((res) => {
              const blob = new Blob([res.data])
              this.pdfParams.data = '/pdfjs/web/viewer.html?file=' + window.URL.createObjectURL(blob)
              loading(false)
              this.pdfParams.showPdf = true
          }).catch((res)=> {
            loading(false)
            Toast.fail("文件出错!")
            return
          })
        }else {
            loading(false)
            Toast.fail(res.message)
        }
      })
      
    },
    onClickLeft () {
        this.$router.push('/');
    },
    getpdfShow(data) {
        this.pdfParams.showPdf = data;
    },
    handleDateChange(val) {
      this.date.type = val
      if(this.date.type == 1) {
        this.date.currentDate = this.date.startDate ? new Date(this.date.startDate) : new Date()
      }else {
        this.date.currentDate = this.date.endDate ? new Date(this.date.endDate) : new Date()
      }
      this.date.visible = true
    },
    confirm() {
      if(this.date.type == 1) {
        this.date.startDate =  this.formatter(this.date.currentDate)
      }else {
        this.date.endDate =  this.formatter(this.date.currentDate)
      }
      this.date.visible = false
    },
    cancel() {
      this.date.visible = false
    },
    formatter(time) {
      let nowdata =time == null ?  new Date() : new Date(time);
      let year = nowdata.getFullYear();
      let month = nowdata.getMonth() + 1;
      let date = nowdata.getDate();
      let nowtime = year + "-";
      if (month < 10) {
        nowtime += "0";
      }
      nowtime += month + "-";
      if (date < 10) {
        nowtime += "0";
      }
      nowtime += date;

      return nowtime;
    },
    handClear(val) {
      if(val == 1) {
        this.date.startDate =  ''
      }else {
        this.date.endDate =  ''
      }
    }
  }
} 